import { useEffect, useState } from "react";

/** Seconds left before something may be tried again (a new code, another email). */
export function useCountdown(initialSeconds = 0): [number, (seconds: number) => void] {
  const [left, setLeft] = useState(Math.max(0, Math.ceil(initialSeconds)));
  useEffect(() => {
    if (left <= 0) return;
    const timer = setTimeout(() => setLeft((value) => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [left]);
  return [left, (seconds) => setLeft(Math.max(0, Math.ceil(seconds)))];
}
